import { BROADCAST_CHANNELS } from "@/config/constants";

export type AuthBroadcastMessage =
  | { type: "logout" }
  | { type: "session-revoked"; reason?: string }
  | { type: "login" };

export type PrefsBroadcastMessage = {
  type: "prefs-updated";
  patch: Record<string, unknown>;
};

class TypedChannel<T> {
  private channel: BroadcastChannel;

  constructor(name: string) {
    this.channel = new BroadcastChannel(name);
  }

  post(message: T) {
    this.channel.postMessage(message);
  }

  subscribe(handler: (message: T) => void): () => void {
    const listener = (event: MessageEvent<T>) => handler(event.data);
    this.channel.addEventListener("message", listener);
    return () => this.channel.removeEventListener("message", listener);
  }
}

export const authChannel = new TypedChannel<AuthBroadcastMessage>(BROADCAST_CHANNELS.AUTH);
export const prefsChannel = new TypedChannel<PrefsBroadcastMessage>(BROADCAST_CHANNELS.PREFS);
